import { render, staticRenderFns } from "./HipotekaSalyginis.vue?vue&type=template&id=6a039b14&scoped=true&"
import script from "./HipotekaSalyginis.vue?vue&type=script&lang=js&"
export * from "./HipotekaSalyginis.vue?vue&type=script&lang=js&"
import style0 from "./HipotekaSalyginis.vue?vue&type=style&index=0&id=6a039b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a039b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VRow,VSpacer})
